import { render, staticRenderFns } from "./start.vue?vue&type=template&id=af0c3fa0&scoped=true"
import script from "./start.vue?vue&type=script&lang=js"
export * from "./start.vue?vue&type=script&lang=js"
import style0 from "./start.vue?vue&type=style&index=0&id=af0c3fa0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0c3fa0",
  null
  
)

export default component.exports